import { saveAs } from 'file-saver'
import ReportsApi from 'api-client/Reports.api'

const ReportsService = {
  async email(reportName, params = {}) {
    return await ReportsApi.email(reportName, params)
  },

  async download(reportName, params = {}) {
    const response = await ReportsApi.download(reportName, params)

    const contentDisposition = response.headers['content-disposition']
    const filename = contentDisposition
      ? contentDisposition.split('filename=')[1].split(';')[0].replace(/"/g, '')
      : `rapportage-${reportName}.xlsx`

    saveAs(response.data, filename)
  },
}

export default ReportsService
